import { createContext, useContext } from 'react';

export type StatusCodeSetter = (code: number) => void;

/**
 * Request-scoped channel for surfacing an HTTP status code from the React tree
 * during server rendering. Replaces the react-router v5 `StaticRouter` `context`
 * (`staticContext.statusCode`) channel, which was removed in v6/v7.
 *
 * On the server the renderer provides a setter that records the code into a
 * request-scoped holder, read after render to set `res.status(...)`. On the
 * client no provider is mounted, so `useStatusCode()` is a no-op.
 */
const StatusCodeContext = createContext<StatusCodeSetter | undefined>(undefined);

export const StatusCodeProvider = StatusCodeContext.Provider;

export const useStatusCode = (): StatusCodeSetter => useContext(StatusCodeContext) ?? (() => {});
